import Cookies from 'js-cookie';

import { pushLoggyEvent } from '../redux/actions/loggy';

import { isEmpty } from './generic';

export const session_id_generator = () =>
  'xxxxxxxxxxxx4xxx'.replace(/x/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;

    return v.toString(16);
  });

export const session_id = () => {
  const storedId = sessionStorage.getItem('session_id');

  if (storedId) return storedId;

  const sessionId = session_id_generator();

  sessionStorage.setItem('session_id', sessionId);

  return sessionId;
};

export const pushEventInLoggy = (data = {}, profile, userId) => {
  const user_id = userId || Cookies.get('user-id');

  const user_name = profile?.data?.data?.full_name;
  const other_properties = { user_name, email: profile?.data?.data?.email, mobile_number: profile?.data?.data?.mobile_number, ...(data?.other_properties || {}) };

  // const user_id = profile?.data?.user_id || 'N/A';

  const application_name = 'awign_expert';
  const origin = 'awign_expert';
  const eventObj = {
    user_id: user_id || 'N/A',
    application_name,
    origin,
    ...data,
    session_id: session_id(),
    event_at: new Date().toJSON()
  };

  eventObj.action = data.event;

  if (!isEmpty(profile)) {
    eventObj.other_properties = other_properties;
  }

  // if (process.env.CONFG_ENV === 'dev') return;

  pushLoggyEvent(eventObj);
};
